import PublicPageTemplate from '../../components/PublicPageTemplate/PublicPageTemplate';
import { useFormConfig } from '../../hooks/useFormConfig';

function AccessibilityStatementScreen() {
  const { formConfig } = useFormConfig();
  const serviceName = (formConfig as any)?.serviceName || 'GRID GovReturns';

  return (
    <PublicPageTemplate title={`Accessibility statement for ${serviceName}`} fullWidth>
      <p className="govuk-body">Last updated: 14 February 2026</p>

      <p className="govuk-body">
        This service is currently in beta. We are working to improve accessibility and we aspire to
        meet the Web Content Accessibility Guidelines (WCAG) 2.2 AA standard.
      </p>

      <p className="govuk-body">
        Whilst the service is under development, please contact{' '}
        <a className="govuk-link" href="mailto:grid-platform@cabinetoffice.gov.uk">
          grid-platform@cabinetoffice.gov.uk
        </a>{' '}
        if you require help accessing a form and we will arrange a solution for you.
      </p>
    </PublicPageTemplate>
  );
}

export default AccessibilityStatementScreen;

